import axios from 'axios';
import axiosFileupload from 'axios-fileupload';
import _ from 'lodash';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

import {
  getHeaders,
  getImageHeaders,
  getMultiPartHeaders,
  getHeadersWithParams,
  getExtraImageHeaders,
  getHeadersMultiPart
} from '../../util/util-network';
import { AXIOS_NO_INTERNET_MESSAGE } from '../../constants/constant';

// actions
import {
  detectedNoInternetInAxios,
  internetConnectionRestored,
  recallCheckEvent,
  setTokenExpiredModal,
  setUnauthorisedApiCall
} from '../../actions';

export function detection(url, session, dispatch, callback) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }

  axios
    .get(`${url}`, getHeaders(session))
    .then(({ data }) => {
      callback({ success: 1, data });
    })
    .catch(error => {
      callback({ success: 0, data: null });
    });
}

export function getRequest(
  url,
  session = null,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }

  const fetchUrl = _.cloneDeep(url);
  let appendEventid = false;
  if (
    _.includes(url, 'filter') &&
    session?.eventid &&
    (!_.isNil(session?.eventid) || !_.isEmpty(session?.eventid))
  )
    appendEventid = true;

  _handleResponse(
    axios.get(
      `${fetchUrl}${appendEventid ? `&eventid=${session?.eventid}` : ''}`,
      getHeaders(session)
    ),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function getCustomRequest(
  url,
  params,
  session,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleResponse(
    axios.get(url, getHeadersWithParams(session, params)),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function postCustomRequest(
  url,
  postBody,
  session,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleResponse(
    axios.post(url, postBody, getHeadersWithParams(session, postBody)),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function postMultipartRequest(
  url,
  postBody,
  session,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleResponse(
    axios.post(url, postBody, getMultiPartHeaders(session)),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function postRequest(
  url,
  postBody,
  session,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleResponse(
    axios.post(url, postBody, getHeaders(session)),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function patchRequest(
  url,
  patchBody,
  session,
  dispatch,
  successCallback,
  errorCallback
) {
  dispatch(hideLoading());
  dispatch(showLoading());
  _handleResponse(
    axios.patch(url, patchBody, getHeaders(session)),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function deleteRequest(
  url,
  session,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleResponse(
    axios.delete(url, getHeaders(session)),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function deleteBulkRequest(
  url,
  session,
  deleteBody,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleResponse(
    axios.delete(url, { data: deleteBody, headers: getHeaders(session) }),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function putRequest(
  url,
  putBody,
  session,
  dispatch,
  successCallback,
  errorCallback
) {
  dispatch(hideLoading());
  dispatch(showLoading());
  _handleResponse(
    axios.put(url, putBody, getHeaders(session)),
    dispatch,
    session,
    successCallback,
    errorCallback
  );
}

export function fileUploadRequest(
  url,
  fileData,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleResponse(
    axiosFileupload(url, fileData),
    dispatch,
    successCallback,
    errorCallback
  );
}

export const uploadEncodedFile = (
  url,
  session,
  fileData,
  dispatch,
  successCallback,
  errorCallback
) => {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleFileResponse(
    axios.post(url, fileData, getImageHeaders(session)),
    dispatch,
    successCallback,
    errorCallback
  );
};

export function uploadEncodedFileLarge(
  url,
  session,
  fileData,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleFileResponse(
    axios.post(url, fileData, getHeadersMultiPart(session)),
    dispatch,
    successCallback,
    errorCallback
  );
}

export function deleteEncodedFile(
  url,
  session,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleFileResponse(
    axios.delete(url, getImageHeaders(session)),
    dispatch,
    successCallback,
    errorCallback
  );
}

export function uploadEncodedFileRemote(
  url,
  session,
  fileData,
  filename,
  dispatch,
  successCallback,
  errorCallback
) {
  if (dispatch) {
    dispatch(hideLoading());
    dispatch(showLoading());
  }
  _handleFileResponse(
    axios.post(url, fileData, getExtraImageHeaders(session, filename)),
    dispatch,
    successCallback,
    errorCallback
  );
}

function _handleFileResponse(
  response,
  dispatch,
  successCallback,
  errorCallback
) {
  response.then(
    response => {
      if (dispatch) dispatch(hideLoading());

      if (response && response.data && response.data.resource) {
        successCallback(response.data.resource[0]);
      } else {
        successCallback(response);
      }
    },
    error => {
      if (dispatch) dispatch(hideLoading());
      errorCallback(error);
    }
  );
}

function _handleResponse(
  response,
  dispatch,
  session = null,
  successCallback,
  errorCallback
) {
  response
    .then(res => {
      if (dispatch) {
        dispatch(hideLoading());
        dispatch(internetConnectionRestored());

        // Maintaining unAuthorizedCall flag for forbidden access
        if (res?.status === 200 && !_.isEmpty(session?.sessionToken)) {
          dispatch(setUnauthorisedApiCall(false));
        }
      }
      successCallback(res?.data);
    })
    .catch(error => {
      if (dispatch) dispatch(hideLoading());

      if (error?.response) {
        switch (error?.response?.status) {
          case 404:
          case 403: // Forbidden access
            if (dispatch && session) {
              dispatch(
                recallCheckEvent(session, res => {
                  successCallback({ success: res }); // Boolean value
                })
              );
            }
            break;

          case 401:
            dispatch(setTokenExpiredModal(true));
            break;

          case 500:
          default:
            errorCallback(error.response.data.error);
            break;
        }
      } else {
        try {
          if (
            _.isEqual(typeof error, 'object') &&
            _.isEqual(error?.toJSON()?.message, AXIOS_NO_INTERNET_MESSAGE)
          ) {
            successCallback({});
            if (dispatch) dispatch(detectedNoInternetInAxios());
          } else errorCallback(error);
        } catch (localError) {
          errorCallback(error);
        }
      }
    });
}
